import { knowledgeItemExclusionApi, knowledgeItemsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const KNOWLEDGE_ITEMS_ACTION_TYPE = createNamedActions('knowledgeItems', {
  GET_KNOWLEDGE_ITEMS: 'GET_KNOWLEDGE_ITEMS',
  CREATE_KNOWLEDGE_ITEM: 'CREATE_KNOWLEDGE_ITEM',
  UPDATE_KNOWLEDGE_ITEM: 'UPDATE_KNOWLEDGE_ITEM',
  DELETE_KNOWLEDGE_ITEM: 'DELETE_KNOWLEDGE_ITEM',
  TOGGLE_KNOWLEDGE_ITEM_EXCLUSION: 'TOGGLE_KNOWLEDGE_ITEM_EXCLUSION',
  RESET_KNOWLEDGE_ITEMS_STATE: 'RESET_KNOWLEDGE_ITEMS_STATE',
});

export const getKnowledgeItemsAction = catchAsyncActionError(
  ({ skipForbiddenError = false } = {}) =>
    async dispatch => {
      const { data } = await knowledgeItemsApi.getKnowledgeItems({ skipForbiddenError });

      return dispatch({
        type: KNOWLEDGE_ITEMS_ACTION_TYPE.GET_KNOWLEDGE_ITEMS,
        payload: data,
      });
    },
);

export const createKnowledgeItemAction = catchAsyncActionError(
  ({ isGlobal, ...body }) =>
    async dispatch => {
      const { data } = await knowledgeItemsApi.createKnowledgeItem(body, { isGlobal });

      return dispatch({
        type: KNOWLEDGE_ITEMS_ACTION_TYPE.CREATE_KNOWLEDGE_ITEM,
        payload: data,
      });
    },
);

export const updateKnowledgeItemAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await knowledgeItemsApi.updateKnowledgeItem(params);

  return dispatch({
    type: KNOWLEDGE_ITEMS_ACTION_TYPE.UPDATE_KNOWLEDGE_ITEM,
    payload: data,
  });
});

export const deleteKnowledgeItemAction = catchAsyncActionError(id => async dispatch => {
  await knowledgeItemsApi.deleteKnowledgeItem(id);

  return dispatch({
    type: KNOWLEDGE_ITEMS_ACTION_TYPE.DELETE_KNOWLEDGE_ITEM,
    payload: id,
  });
});

export const excludeKnowledgeItemAction = catchAsyncActionError(
  ({ knowledgeItemId }) =>
    async dispatch => {
      await knowledgeItemExclusionApi.excludeKnowledgeItem({ knowledgeItemId });

      return dispatch({
        type: KNOWLEDGE_ITEMS_ACTION_TYPE.TOGGLE_KNOWLEDGE_ITEM_EXCLUSION,
        payload: { knowledgeItemId, isExcluded: true },
      });
    },
);

export const includeKnowledgeItemAction = catchAsyncActionError(
  ({ knowledgeItemId }) =>
    async dispatch => {
      await knowledgeItemExclusionApi.includeKnowledgeItem({ knowledgeItemId });

      return dispatch({
        type: KNOWLEDGE_ITEMS_ACTION_TYPE.TOGGLE_KNOWLEDGE_ITEM_EXCLUSION,
        payload: { knowledgeItemId, isExcluded: false },
      });
    },
);

export const resetKnowledgeItemsStateAction = () => ({
  type: KNOWLEDGE_ITEMS_ACTION_TYPE.RESET_KNOWLEDGE_ITEMS_STATE,
});
